import { Icons, Tooltip } from '@commenda/kakashi';

import { ChatIconButton } from './ChatIconButton';

interface PanelCloseButtonProps {
  onClose: () => void;
  /** What the button closes, for its tooltip and screen-reader label. */
  label?: string;
}

/** The close button on every side panel's header, so all of them close the same way. */
export const PanelCloseButton = ({
  onClose,
  label = 'Close chat',
}: PanelCloseButtonProps) => (
  <Tooltip content={label} asChild>
    <ChatIconButton
      aria-label={label}
      onClick={onClose}
      icon={<Icons.XClose className="size-4" />}
    />
  </Tooltip>
);
